var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoEyeClosed = function SvgIcoEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M19.071 5.293a1 1 0 0 0-1.414 0L4.929 18.02a1 1 0 1 0 1.414 1.414L19.071 6.707a1 1 0 0 0 0-1.414M12 6.364q.835.002 1.634.123L11.75 8.372a4 4 0 0 0-3.742 3.742l-3.546 3.545C2.93 14.459 2 13.145 2 12.364c0-1.714 4.477-6 10-6m3.992 6.25a4 4 0 0 1-3.742 3.742l-1.884 1.884q.799.122 1.634.124c5.523 0 10-4.286 10-6 0-.78-.929-2.095-2.462-3.295z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoEyeClosed;